import { createFileRoute } from '@tanstack/react-router'
import { scorecardsRepository } from '@/data/adapters/api/scorecards.api'

export const Route = createFileRoute('/$orgSlug/$clientSlug/reports')({
  loader: ({ context: { queryClient, client } }) =>
    queryClient.ensureQueryData({
      queryKey: ['scorecards', 'monthly', client.id],
      queryFn: () => scorecardsRepository.getMonthlyScorecard(client.id),
    }),
})
